import React, { useState, useEffect } from "react";
import { IconButton, useColorModeValue } from "@chakra-ui/react";
import { ChevronUpIcon } from "@chakra-ui/icons";

const ScrollToTop = ({ bottom = "4" }) => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <IconButton
          position="fixed"
          bottom={bottom}
          right="2"
          zIndex="999"
          bg="#F68633"
          opacity={"0.8"}
          icon={<ChevronUpIcon />}
          onClick={scrollToTop}
          aria-label="Scroll to top"
          borderRadius="full"
          size="lg"
          boxShadow="lg"
          borderColor={"black"}
          border={"1px"}
        />
      )}
    </>
  );
};

export default ScrollToTop;
